import React from "react";
import { useDroppable } from "@dnd-kit/core";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DragItem from "../drag-item";
import { BACKEND_DROPPABLE_ID } from "../../../utils";

const BackEndColumn = ({ column }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: BACKEND_DROPPABLE_ID,
    data: { type: "backend" }
  });

  return (
    <Box
      sx={{
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        p: 1.5,
        flexGrow: 1,
        width: "40%",
        minHeight: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", mb: 1, gap: 1 }}>
        <Typography variant="subtitle2">{column.name}</Typography>
        <Typography variant="caption" color="text.secondary" noWrap>
          {column.list.length} left
        </Typography>
      </Box>
      <Box
        ref={setNodeRef}
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          minHeight: 0,
          flex: 1,
          borderRadius: 1,
          bgcolor: isOver ? "action.hover" : "transparent"
        }}
      >
        {column.list.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Every column is mapped.
          </Typography>
        ) : (
          column.list.map((itemObject) => <DragItem key={itemObject.id} itemObject={itemObject} />)
        )}
      </Box>
    </Box>
  );
};

export default BackEndColumn;
